<i class="cs-icon cs-icon-video text-sm" (click)="onOpen()" [matTooltip]="info" matTooltipPosition="below"></i>
